var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easyquery/core';
import { ResultFacet } from './result_facet';
import { FacetType } from '../types/facet_type';
import { EasyGridWidget } from '../widgets/easy_grid_widget';
var DataTableFacet = /** @class */ (function (_super) {
    __extends(DataTableFacet, _super);
    function DataTableFacet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.grid = null;
        _this.title = i18n.getText('Facets', 'DataTable', 'FacetTitle');
        _this.dialogTitle = i18n.getText('Facets', 'DataTable', 'DlgTitle');
        return _this;
    }
    DataTableFacet.prototype.init = function (slot) {
        _super.prototype.init.call(this, slot);
        this.reinitGrid();
    };
    DataTableFacet.prototype.getSettings = function () {
        return this.settings;
    };
    DataTableFacet.prototype.reinitGrid = function () {
        if (this.grid)
            this.grid.destroy();
        var options = this.container.options || {};
        if (options.gridResolver) {
            this.grid = options.gridResolver(this.contentDiv, this.getType());
        }
        if (this.grid == null) {
            this.grid = new EasyGridWidget(this.contentDiv);
        }
        options.grid = options.grid || {};
        options.grid.autoRefresh = false;
        options.grid.addColumns = false;
        var context = this.getContext();
        options.grid.totals = this.settings;
        this.grid.init(context, options.grid);
    };
    DataTableFacet.prototype.getType = function () {
        return FacetType.DataGrid;
    };
    DataTableFacet.prototype.canDisplay = function () {
        return true;
    };
    DataTableFacet.prototype.refreshCore = function () {
        if (!this.grid)
            return;
        this.grid.refresh();
    };
    DataTableFacet.prototype.destroy = function () {
        if (this.grid) {
            this.grid.destroy();
        }
    };
    return DataTableFacet;
}(ResultFacet));
export { DataTableFacet };
//# sourceMappingURL=datatable_facet.js.map